var map = {
	"./dy_entry/bg.jpg": 457,
	"./explain/part1.png": 4691,
	"./explain/part2.png": 4538,
	"./explain/part3.png": 8209,
	"./favicon/apple-touch-icon.png": 112,
	"./favicon/cover.jpg": 1561,
	"./favicon/favicon-16x16.png": 2229,
	"./favicon/favicon-32x32.png": 6552,
	"./favicon/favicon.ico": 553,
	"./favicon/favicon.png": 756,
	"./login/logo_circle.png": 983,
	"./login/logo_text.png": 6486,
	"./official_website/about/banner.png": 6511,
	"./official_website/about/banner_mobile.png": 9768,
	"./official_website/about/company_logo.png": 9668,
	"./official_website/about/tag1.png": 858,
	"./official_website/about/tag2.png": 7275,
	"./official_website/article/android.png": 8173,
	"./official_website/article/detail/android.png": 8748,
	"./official_website/article/detail/ios.png": 2531,
	"./official_website/article/detail/logo.png": 8673,
	"./official_website/article/ios.png": 292,
	"./official_website/backflow/banner.png": 838,
	"./official_website/backflow/bg-mobile.png": 81,
	"./official_website/backflow/line_h.png": 7692,
	"./official_website/backflow/line_v.png": 9274,
	"./official_website/backflow/qrcode.png": 2852,
	"./official_website/backflow/step1.png": 4910,
	"./official_website/backflow/step2.png": 2384,
	"./official_website/backflow/step3.png": 9423,
	"./official_website/backflow/title.png": 3642,
	"./official_website/backtotop.png": 1434,
	"./official_website/download/bg.png": 311,
	"./official_website/download/prompt.png": 4431,
	"./official_website/home/BSH_company.png": 5189,
	"./official_website/home/GHMZ_company.png": 4099,
	"./official_website/home/ZJTC_company.png": 7525,
	"./official_website/home/android_download.png": 3992,
	"./official_website/home/bg_top.png": 2526,
	"./official_website/home/bg_top_mobile.png": 3416,
	"./official_website/home/bg_top_phone.png": 6268,
	"./official_website/home/company-logo.png": 3922,
	"./official_website/home/company1.png": 6673,
	"./official_website/home/company2.png": 8846,
	"./official_website/home/count-line.png": 9973,
	"./official_website/home/intro1.png": 661,
	"./official_website/home/intro2.png": 2579,
	"./official_website/home/intro3.png": 9611,
	"./official_website/home/ios_download.png": 8407,
	"./official_website/home/logo.png": 8400,
	"./official_website/home/posts_temp.png": 6851,
	"./official_website/home/process-line.png": 4583,
	"./official_website/home/process1.png": 7530,
	"./official_website/home/process2.png": 4739,
	"./official_website/home/process3.png": 3387,
	"./official_website/home/process4.png": 6417,
	"./official_website/home/qrcode.png": 9512,
	"./official_website/home/qrcode2.png": 6790,
	"./official_website/home/qrcode3.png": 8495,
	"./official_website/home/qrcode4.png": 9286,
	"./official_website/logo.png": 8817,
	"./official_website/logo_bottom.png": 6338,
	"./plus-icon.png": 5940,
	"./wechat.png": 7413,
	"./welfare/arrow.png": 9054,
	"./welfare/icon.png": 2926,
	"./welfare/part1.png": 9909,
	"./welfare/part2.png": 140,
	"./welfare/part3.png": 8612,
	"./welfare/part4.png": 4967,
	"./welfare/part5.png": 2612,
	"./welfare/status/created.png": 3832,
	"./welfare/status/fail.png": 6131,
	"./welfare/status/pending.png": 5073,
	"./welfare/status/send.png": 6460,
	"./welfare/status/success.png": 6983
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8999;